import React from "react";
import PropTypes from "prop-types";
import { CircularProgress, Box, Typography, IconButton } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
export default function CircularProgressWithLabel(props) {
  const [border, setBorder] = React.useState((props.count / props.value) * 100);
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        sx={{ width: "45px !important", height: "45px !important" }}
        color={border > 0 ? "success" : "accent"}
        variant="determinate"
        value={border > 0 ? border : 100}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {`${props["count"]}/${props["value"]}`}
        </Typography>
      </Box>

      {props.value === 100 ? (
        <DoneIcon
          sx={{
            position: "absolute",
            background: "#2CF488",
            top: -3,
            left: 0,
            right: 0,
            margin: "auto",
            borderRadius: "50%",
            fontSize: "12px",
          }}
          color="secondary"
        />
      ) : null}
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
};
